import type { ReactNode } from 'react'
import { UIVariantProvider as SharedUIVariantProvider, type UIVariantService } from '@agion/ui/ui-variant'
import { useAuth } from '@/shared/auth/unified-auth'
import { getUIVariantResolution } from './ui-variant.service'

// The boot contract lives in @agion/ui/ui-variant, shared with chat (PLAN-20260929
// slice 1); the console supplies its member and its API client here.
const consoleService: UIVariantService = {
  getResolution: (signal) => getUIVariantResolution(signal),
}

export function UIVariantProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  return (
    <SharedUIVariantProvider user={user} service={consoleService}>
      {children}
    </SharedUIVariantProvider>
  )
}
